import classNames from 'classnames';

import { setupForDark } from '@theme';

function InputLabel({
  label,
  type = 'editor-active',
  className = ''
}: {
  label: string;
  type?: 'editor-active' | 'editor-readonly';
  className?: string;
}) {
  return (
    <div
      className={classNames(
        type === 'editor-active' ? 'P4R' : 'P5R',
        setupForDark('text-tertiary'),
        className
      )}
    >
      {label}
    </div>
  );
}

export default InputLabel;
